import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { PuffLoader } from 'react-spinners';

import { useConfig } from 'config/ConfigContext';
import withPlaidSessionId from './WithPlaidSession';
import style from './style.scss';

import { exitPlaid } from 'actions/plaid';

const Plaid = (props) => {
  const config = useConfig();
  const dispatch = useDispatch();
  const plaidComponent = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleEvent = (eventName) => {
    if (eventName === 'OPEN') {
      document.body.style.overflow = 'auto';
    }
  };

  const onPlaidLoad = () => {
    setIsLoading(false);
  };

  const onPlaidSuccess = (publicToken, metadata) => {
    props.onPlaidSuccess(publicToken, metadata, props.sessionId);
    plaidComponent.current && plaidComponent.current.destroy();
  };

  const loadScript = (url, callback) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) { // IE
      script.onreadystatechange = () => {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else { // Others
      script.onload = () => {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  const onPlaidExit = (err, metadata) => {
    dispatch(exitPlaid({
      data: {
        error: err,
        institution: metadata.institution,
        linkSessionId: metadata.link_session_id,
        requestId: metadata.request_id,
        status: metadata.status,
      },
      apiUrl: `${config.apiUrl}/plaid/session/${props.sessionId}/exit`,
    }));
    plaidComponent.current && plaidComponent.current.destroy();
    props.onPlaidExit();
  };

  const loadPlaid = useCallback(() => {
    const { linkToken } = props;
    plaidComponent.current = window.Plaid.create({
      token: linkToken,
      onLoad: onPlaidLoad,
      onSuccess: onPlaidSuccess,
      onExit: onPlaidExit,
      onEvent: handleEvent,
    });
    plaidComponent.current.open();
  }, [props.linkToken]);

  useEffect(() => {
    loadScript('https://cdn.plaid.com/link/v2/stable/link-initialize.js', () => {
      loadPlaid();
    });
  }, [props.linkToken]);

  return (
    <div className={style.plaidContainer}>
      {
        isLoading &&
          <PuffLoader
            color="#f44242"
            size={100}
          />
      }
    </div>
  );
};

Plaid.propTypes = {
  sessionId: PropTypes.string.isRequired,
  linkToken: PropTypes.string.isRequired,
  onPlaidSuccess: PropTypes.func.isRequired,
  onPlaidExit: PropTypes.func.isRequired,
};

export default withPlaidSessionId(Plaid);
